/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React, { useEffect } from 'react';
import { Header, AppCardListComp, SettingsComp } from '../components';
import { useSMActualPoliciesGetContent } from '@pages/ActualPolicyPage/machines';
import { NotificationModal } from '@vlinder-web/notification-modal-v2-widget-react';
import { StateOSD } from '@vlinder-web/state-osd-v2-widget-react';
import { Paginate } from '@vlinder-web/paginate-widget-react';
import { ActualPoliciesPageService } from '@pages/ActualPolicyPage/services';
import { vappContainer } from '@/application';
import { SearchFilter } from '@/widgets/filter-widget-react';

const getSrv = () => {
  return vappContainer.get<ActualPoliciesPageService>(
    ActualPoliciesPageService.displayName
  );
};

export const ContainerComm = (props: any) => {
  const srv = getSrv();
  useEffect(() => {
    srv?.resetCriteria();
  }, []);

  const staticPageContentConfig = getSrv()?.agent.getStaticContentSync();
  const {
    actualPoliciesPageMachine,
    actualPoliciesPageSend,
    actualPoliciesPageState,
  } = useSMActualPoliciesGetContent({});

  const onPaginationChange = (event: any) => {
    console.log(`page selected`, event?.selected);
    actualPoliciesPageSend('TRIGGER_REFRESH', {
      offset: event?.selected * 12,
      size: 12,
    });
  };

  const onRefresh = () => {
    actualPoliciesPageSend('TRIGGER_REFRESH', {});
  };

  const onClearFilter = () => {
    srv?.resetCriteria();
    actualPoliciesPageSend('TRIGGER_REFRESH', {});
  };

  const onApplyFilter = (data: any) => {
    let criteria: any = [];
    criteria =
      Array.isArray(data) &&
      data.length > 0 &&
      data.map((item: any) => {
        return {
          column: item?.filters?.inputData?.id,
          op: item?.filters?.inputData?.label,
          value: [item?.filters[item?.filters?.inputData?.label]],
        };
      });
    actualPoliciesPageSend('TRIGGER_REFRESH', {
      where: criteria,
    });
  };

  const _renderPagination = () => {
    if (!actualPoliciesPageState?.event?.data?.value?.isEmpty) {
      return (
        <Paginate
          {...(actualPoliciesPageState?.event?.data?.value || {})}
          onPageChange={onPaginationChange}
          totalItems={
            actualPoliciesPageState?.event?.data?.value?.appCardList?.length
          }
        />
      );
    }
  };

  const _renderErrorModals = () => {
    if (actualPoliciesPageState?.matches('RENDER_PAGE_ERROR')) {
      return (
        <NotificationModal
          showModal={true}
          {...(staticPageContentConfig?.error?.getTemplateList || {})}
          onAcknowledgement={onRefresh}
          onDeny={onRefresh}
        />
      );
    }
  };

  const _renderPage = () => {
    console.log('renderpage', actualPoliciesPageState?.event?.data?.value);
    if (actualPoliciesPageState?.matches('RENDER_PAGE')) {
      return (
        <>
          <AppCardListComp
            {...(actualPoliciesPageState?.event?.data?.value || {})}
            onCardClick={props?.onCardClick}
            emptyListProps={staticPageContentConfig?.empty?.myPolicies || {}}
          />
        </>
      );
    }

    if (actualPoliciesPageState?.matches('GET_PAGE_CONTENT')) {
      return (
        <StateOSD
          {...(staticPageContentConfig?.loading?.retrieveCredentials || {})}
        />
      );
    }
    return null;
  };

  const _renderHeader = () => {
    if (staticPageContentConfig?.header) {
      return (
        <>
          <Header
            {...(staticPageContentConfig?.header || {})}
            onRefreshClick={onRefresh}
          />
          <SearchFilter
            {...staticPageContentConfig?.settings}
            onFilterApply={onApplyFilter}
            onClearFilter={onClearFilter}
          />
        </>
      );
    }
    return null;
  };

  const _renderSearch = () => {
    return (
      <SearchFilter
        {...(staticPageContentConfig?.settings || {})}
        onClearFilter={onClearFilter}
        onFilterApply={onApplyFilter}
      />
    );
  };

  return (
    <>
      {_renderHeader()}
      {/* {_renderSearch()} */}
      {_renderPage()}
      {_renderErrorModals()}
      {_renderPagination()}
    </>
  );
};
